import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import './AmexGDAB2BMoreDetails.scss';

const AmexGDAB2BMoreDetails = (
  {
    baseRequestUrl,
    hungryForDetailsConfig: {
      copy,
      cta,
      image,
      pdf_aria: pdfAria,
      pdf_icon: pdfIcon,
      title,
    },
    Analytics,
    matchMedia,
  }
) => {
  if (!copy || !title || !cta) return null;
  const label = cta?.label;
  const url = cta?.url;

  if (!label || !url) return null;
  const desktopImg = image?.desktop;
  const mobileImg = image?.mobile;
  const bgImage = matchMedia.md ? desktopImg : mobileImg;
  const bgImageSrc = `url(${baseRequestUrl}AmexGDAB2B/images/MoreDetails/${bgImage})`;

  const sanitizedTitle = sanitizeString(title);
  const sanitizedCopy = sanitizeString(copy);

  return (
    <section className="AmexGDAB2BMoreDetails">
      <div className="container">
        <div
          className="AmexGDAB2BMoreDetails__body"
          style={{
            backgroundImage: bgImageSrc,
          }}
        >
          <h2
            className="AmexGDAB2BMoreDetails__title"
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedTitle,
            }}
          />
          <p>
            <span
              className="AmexGDAB2BMoreDetails__text"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedCopy,
              }}
            />
            <Link
              className="AmexGDAB2BMoreDetails__cta"
              href={`${baseRequestUrl}AmexGDAB2B/pdf/${url}`}
              target="_blank"
              onClick={() => {
                const extraParam = {
                  action_name: 'Hungry For More Details - Click',
                };
                handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
              }}
            >
              <span className="label">{label}</span>
              <img src={`${baseRequestUrl}AmexGDAB2B/images/${pdfIcon}`} alt={pdfAria} />
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

AmexGDAB2BMoreDetails.propTypes = {
  baseRequestUrl: PropTypes.string.isRequired,
  hungryForDetailsConfig: PropTypes.shape({
    copy: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    cta: PropTypes.shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      event_tag: PropTypes.string.isRequired,
    }),
    image: PropTypes.shape({
      desktop: PropTypes.string.isRequired,
      mobile: PropTypes.string.isRequired,
    }),
    pdf_aria: PropTypes.string.isRequired,
    pdf_icon: PropTypes.string.isRequired,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
};

export default AmexGDAB2BMoreDetails;
